import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

export function ButtonAnimate({ children }) {
  return (
    <motion.div whileTap={{ scale: 0.98 }} whileHover={{ scale: 1.02 }}>
      {children}
    </motion.div>
  );
}

ButtonAnimate.propTypes = {
  children: PropTypes.node
};

export const varFadeInRight = {
  initial: { x: 40, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 20, opacity: 0 },
  transition: { duration: 0.2 }
};
